// import { backendURl } from "../utils/baseUrls";
// import setAuthToken from "../utils/setAuthToken";
// import ERC20ABI from "../assets/abi/ERC20.json";
// import NFTABI from "../assets/abi/NFT.json";
// import NFTMarketplaceABI from "../assets/abi/NFT_Marketplace.json";
// import { singhCoinAddress } from "../Utils/config";
// import { nftContractAddress, nftMarketPlaceAddress } from "../Utils/config";

import ERC20ABI from "assets/abi/ERC20.json";
import NFTABI from "assets/abi/NFT.json";
import NFTMarketplaceABI from "assets/abi/NFT_Marketplace.json";
import {
  singhCoinAddress,
  nftContractAddress,
  nftMarketPlaceAddress,
} from "utils/config";

export const getUserTokenBalance = async (web3, walletAddress) => {
  try {
    const tokenContract = await new web3.eth.Contract(
      ERC20ABI,
      singhCoinAddress
    );
    const bal = await tokenContract.methods.balanceOf(walletAddress).call();
    // console.log("bal", bal);
    return { tokenBal: web3.utils.fromWei(bal) };
  } catch (error) {
    return error;
  }
};

export const mintNFT = async (web3, address, royalties, metaDataHash) => {
  // console.log("web3", web3);
  // console.log("address", address);
  console.log("royalties", Number(royalties) * 10);
  // console.log("hash", metaDataHash);

  try {
    const mintPost = new web3.eth.Contract(NFTABI, nftContractAddress);
    const newMintPost = await mintPost.methods
      .safeMint(address, metaDataHash, Number(royalties) * 10)
      .send({
        from: address, // walletAddress
      });
    // console.log("newMintPost", newMintPost);

    return newMintPost;
  } catch (err) {
    console.log("errr", err);
    return err;
  }
};

export const mintNFTMarketPlace = async (
  web3,
  address,
  tokenId,
  price,
  sellingStatus
) => {
  // console.log("web3", web3);
  // console.log("address", address);
  // console.log("tokenId", tokenId);
  // console.log("price", price);
  // console.log("sellingStatus", sellingStatus);

  try {
    const weiPrice = await web3.utils.toWei(price.toString(), `ether`);
    // console.log("weiPrice", weiPrice);

    const approveContract = new web3.eth.Contract(NFTABI, nftContractAddress);
    const contractApproved = await approveContract.methods
      .approve(nftMarketPlaceAddress, Number(tokenId))
      .send({
        from: address, // walletAddress
      });
    // console.log("contractApproved", contractApproved);
    if (contractApproved.transactionHash) {
      const mintPostNftmarketPlace = new web3.eth.Contract(
        NFTMarketplaceABI,
        nftMarketPlaceAddress
      );

      if (sellingStatus === "For sale") {
        const postMarketplace = await mintPostNftmarketPlace.methods
          .sellWithSingh(nftContractAddress, Number(tokenId), weiPrice)
          .send({
            from: address, // walletAddress
          });
        // console.log("postMarketplace", postMarketplace);
        return postMarketplace;
      } else {
        const postMarketplace = await mintPostNftmarketPlace.methods
          .setForAuction(nftContractAddress, Number(tokenId), weiPrice)
          .send({
            from: address, // walletAddress
          });
        // console.log("postMarketplace2", postMarketplace);
        return postMarketplace;
      }
    } else {
      return "Transaction Failed";
    }
  } catch (err) {
    console.log("errr", err);
    return err;
  }
};

export const buyNft = async (web3, address, tokenId, price) => {
  // console.log("web3", web3);
  // console.log("address", address);
  // console.log("tokenId", tokenId);
  // console.log("price", price);

  try {
    const weiPrice = await web3.utils.toWei(price.toString(), `ether`);
    // console.log("weiPrice", weiPrice);

    const buyContract = new web3.eth.Contract(ERC20ABI, singhCoinAddress);

    const contractApproved = await buyContract.methods
      .approve(nftMarketPlaceAddress, weiPrice)
      .send({
        from: address, // walletAddress
      });

    if (contractApproved.transactionHash) {
      const boughtNftContract = new web3.eth.Contract(
        NFTMarketplaceABI,
        nftMarketPlaceAddress
      );

      // console.log("nftAdd", nftContractAddress, tokenId, weiPrice);
      const boughtNft = await boughtNftContract.methods
        .buyNFT("SINGH", nftContractAddress, Number(tokenId), weiPrice)
        .send({
          from: address, // walletAddress
        });

      // console.log("boughtNFT", boughtNft);
      return boughtNft;
    }

    // return boughtNft;
  } catch (err) {
    console.log("errr", err);
    return err;
  }
};

export const bidNft = async (web3, address, price) => {
  // console.log("web3", web3);
  // console.log("address", address);
  // console.log("price", price);

  try {
    const weiPrice = await web3.utils.toWei(price.toString(), `ether`);
    // console.log("weiPrice", weiPrice);

    const buyContract = new web3.eth.Contract(ERC20ABI, singhCoinAddress);

    const contractApproved = await buyContract.methods
      .approve(nftMarketPlaceAddress, weiPrice)
      .send({
        from: address, // walletAddress
      });

    return contractApproved;
  } catch (err) {
    console.log("errr", err);
    return err;
  }
};

export const acceptBidNft = async (
  web3,
  address,
  tokenId,
  price,
  bidderAddress
) => {
  // console.log("web3", web3);
  // console.log("address", address);
  // console.log("tokenId", tokenId);
  // console.log("price", price);
  // console.log("bidderAddress", bidderAddress);

  try {
    const weiPrice = await web3.utils.toWei(price.toString(), `ether`);
    // console.log("weiPrice", weiPrice);

    const acceptBidContract = new web3.eth.Contract(
      NFTMarketplaceABI,
      nftMarketPlaceAddress
    );

    const bidAccepted = await acceptBidContract.methods
      .acceptBid(
        "SINGH",
        nftContractAddress,
        Number(tokenId),
        weiPrice,
        bidderAddress
      )
      .send({
        from: address, // walletAddress
      });

    return bidAccepted;
  } catch (err) {
    console.log("errr", err);
    return err;
  }
};

export const changePriceNft = async (web3, address, tokenId, price) => {
  // console.log("web3", web3);
  // console.log("address", address);
  // console.log("tokenId", tokenId);
  // console.log("price", price);

  try {
    const weiPrice = await web3.utils.toWei(price.toString(), `ether`);
    // console.log("weiPrice", weiPrice);

    const changePriceContract = new web3.eth.Contract(
      NFTMarketplaceABI,
      nftMarketPlaceAddress
    );
    const changedPrice = await changePriceContract.methods
      .changePriceForSingh(nftContractAddress, Number(tokenId), weiPrice)
      .send({
        from: address, // walletAddress
      });
    // console.log("changedPrice", changedPrice);

    return changedPrice;
  } catch (err) {
    console.log("errr", err);
    return err;
  }
};

export const removeNftAuction = async (web3, address, tokenId) => {
  // console.log("web3", web3);
  // console.log("address", address);
  // console.log("tokenId", tokenId);

  try {
    const removeAuctionContract = new web3.eth.Contract(
      NFTMarketplaceABI,
      nftMarketPlaceAddress
    );
    const removedNftAuction = await removeAuctionContract.methods
      .removeFromSellbySingh(nftContractAddress, Number(tokenId))
      .send({
        from: address, // walletAddress
      });
    // console.log("removedNftAuction", removedNftAuction);

    return removedNftAuction;
  } catch (err) {
    console.log("errr", err);
    return err;
  }
};
